// This is a file to include all custom code injection in the theme
// Created on 06-15-2020 by freelancer: bangank36
/*
	EXPLAINATION:
    - Related file estimated-shipping-default.js
    - Changes:
    1. theme.liquid
    Line 64, change jquery version to 1.9.1 to matched version used in the app to fire custom change event on the dropdown
    Line 211, include custom-script.js file
    
    2. product.test.liquid - probably product.liquid
    Line 139 to 175, disable the modal by hiding them and create duplicate wrap #estimated-shipping-wrap, hide the dropdown and the result
    
    3. custom-script.js
    Use observer to detec when dropdown show up
    Try catch to prevent error on the main app file that can break the script

*/
// unsure if needed Due to Ot-estimated code replaced
/* Watch for changes in estimated-shipping-wrap element to grab all the estimated shipping values */
$(function() {
  if (document.querySelector('#estimated-shipping-wrap .ot-estimated-shipping')) {
    // Use observerMutation to detect when the dropdown is populated into dom
	new MutationObserver(function(mutations, observer) {
        // Iterate over the dropdown options, ignore first item for the empty default one
        $("#estimated-shipping-wrap .ot-estimated-shipping-shipping-methods-select-box option:not(:first-child)").each(function(i, el) {
        	var val = $(el).attr("value");
          	var estimatedTemplate = '<div class="{show_or_hide}" style="margin-bottom: 20px; margin-top:-10px; width:100%"><i class="material-icons-outlined md-18" >{materialicon}</i> {estimated_location}<span class="ot-estimated-shipping-main-text"> delivery: <strong>{estimated_date}</strong></span></div>';
          	// Manually change dropdown value and get the returned data, use try catch call the apps always broken on line 959
            try {
            	$(".ot-estimated-shipping-shipping-methods-select-box").val(val).trigger("change"); 
              	populateItem($(el).text());
              
            } catch(e) {
              	populateItem($(el).text());
            }
          
          	function populateItem(location) {
              	var tpl = estimatedTemplate;
          		var estimated_date = document.querySelector(".ot-estimated-shipping-basic-layout").innerText;
              	
              	var materialicon  = 'fast_forward';  
                var show_or_hide = 'ot-estimated-shipping-item';
                
                const express = "Express";
                const standard = "Standard"; 
                const dispatch = "Dispatch";
                if (location.includes(dispatch)) {
                   show_or_hide = 'hide_shipping';
                }
                if (location.includes(express)) {
                	materialicon = 'access_time';

                } else if (location.includes(standard)) {
                	materialicon='local_shipping';
                }
                else {
                	materialicon='fast_forward';
                }
              
              	tpl = tpl.replace("{estimated_date}", estimated_date);
              	tpl = tpl.replace("{estimated_location}", location.trim());
              	tpl = tpl.replace("{materialicon}", materialicon);
                tpl = tpl.replace("{show_or_hide}", show_or_hide);
              
              	$(tpl).insertAfter(".ot-estimated-shipping");
          	}

        });
		
        // Stop observing if needed:
        observer.disconnect();
    }).observe(document.querySelector('#estimated-shipping-wrap .ot-estimated-shipping'), {childList: true});
  }
});

// Created on 06-31-2020 by freelancer: bangank36
/*
	EXPLAINATION:
    - Related file api.jquery.js and script.js
    - Changes:
    1. On the products which has variants, the Shopify.formatMoney is used and somehow the money_format has been turn into $, 
    find the correct symbol for each currency to fix

*/
$(function() {
  var currencySymbol = {
    GBP: "£",
    USD: "$",
    EUR: "€"
  }
  var symbol = "$";
  if (Shopify.currency && Shopify.currency.active) {
    symbol = currencySymbol[Shopify.currency.active] || symbol;
  }
  Shopify.money_format = symbol+"{{amount}}";
});
